<template lang="pug">
  .container-main.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/merchants-information") 商户资料
          el-breadcrumb-item 修改失败钱包
    cBox.display-flex(v-loading="loading", :element-loading-fullscreen="false")
      div
      el-form(label-position="right", label-width="200px")
        el-row(:gutter="10",v-for='(item,idx) in mch_public_draft_list',:key="idx")
          .wallet-info
            el-col(:span="24")
              el-form-item(label="失败原因",required) {{item.failed_reason}}
            el-col(:span="12")
              el-form-item(label="钱包名",required)
                el-input(v-model.trim="item.public_account_name",disabled)
              el-form-item(label="开户名",required)
                el-input(v-model.trim="item.public_account_name",disabled)
              el-form-item(label="开户银行",required)
                el-select(v-model="item.bankObj.bankClass", clearable, @change="getBankAreaList(item.bankObj)", filterable,value-key="class_code")
                  el-option(v-for="b in bankClassList", :key="b.class_code", :value="b", :label="b.class_name")
              el-form-item(label="开户银行所在地",required)
                el-select(v-model.trim="item.bankObj.bankArea", @change="getBankList(item.bankObj)", clearable, filterable,value-key="area_code")
                  el-option(v-for="b in item.bankObj.bankAreaList", :key="b.area_code", :value="b", :label="b.province_name + b.city_name")
              el-form-item(label="支行名称",required)
                el-select(v-model.trim="item.bankObj.bank", clearable, filterable, value-key="bank_code", @change="getBank(item.bankObj)" )
                  el-option(v-for="b in item.bankObj.bankList", :key="b.bank_code", :value="b", :label="b.bank_name")
              el-form-item(label="对公账户账号",required)
                el-input(v-model.trim="item.public_account")
            el-col(:span="12")
              el-form-item(label="对公账户证明",required)
                el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                  :show-file-list="false", :on-change="(file) => uploadPublicChange(file, idx)")
                  el-button(type="primary") 选择文件
              el-form-item(label="")
                  img(v-if="item.public_account_pic", :src="item.public_account_pic | image", 
                  @click="$zoom($options.filters.image(item.public_account_pic))").mch-image
                  template(v-else) 未上传
      h4 资料修改申请
      .confirm-row   
        el-row(:gutter="20")
          el-col(:span="24")
            div 为符合支付机构对商户资料安全的监管要求，修改除责任人姓名、责任人证件号码以外的其他信息时，需下载填写申请函模板内容，并打印、加盖公司公章，上传复印件，并将原件交给平台商务负责人。
          el-col(:span="24")
            el-form(ref="form" :model="form" label-width="240px")
              el-form-item(label="资料修改申请函",required)
                a(href="./down/资料修改申请函.docx" download="资料修改申请函.docx") 点击下载
              el-form-item(label="申请函",required)
                div 请上传1-9张JPG或PNG格式的图片
                el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                  :show-file-list="false", :on-change="(file) => uploadListChange(file)")
                  el-button(type="primary") 选择文件
                el-form-item(label="")
                  .img-block(v-for="(item,$index) in change_apply_pic")
                    img(v-if="item", :src="item | image", @click="$zoom($options.filters.image(item))").mch-image.mr-20
                    .del-img(@click="delImg($index)") 删除
                  template(v-if="change_apply_pic.length===0") 未上传
      .align-center
        el-button(type="primary", @click="saveEdit") 确认修改

    verifier(ref="modifyMch", @success_verify="toSaveEdit", @abort="abortEdit", scene="MODIFY_INFO", opt="MCH_VERIFY")
</template>

<script>
import { errorDictionaries } from "@/gadgets/dictionaries";
export default {
  data() {
    return {
      source: {
        type: 1,
        mch_name: null,
        business_license: null,
        legal_per_name: null,
        resp_per_id_type: "01",
        resp_per_id_no: null,
        resp_per_name: null,
        resp_per_telephone_no: null,
        resp_per_email: null,
        tel: null,
        business_address: null,
        settle_type: 1,
        deposit_bank: null,
        deposit_bank_province: null,
        deposit_bank_city: null,
        business_license_pic: null,
        business_license_pic_preview: null,
        resp_per_id_positive: null,
        resp_per_id_positive_preview: null,
        resp_per_id_opposite: null,
        resp_per_id_opposite_preview: null,
        legal_per_id_no: null,
        legal_per_id_type: "01",
        organization_code: null,
        public_account: null,
        public_account_name: null,
        public_account_pic: null,
        sub_branch_bank: null,
        tax_registration_no: null,
        union_bank: null,
        legal_per_id_opposite: null,
        legal_per_id_positive: null,
        legal_per_telephone_no: null,
        uni_credit: null,
        class_code: "",
        area_code: "",
        bankArea: {},
        bankClass: {},
        bank: {},
        deposit_bank_id: null,
        area_id: null,
        change_apply_pic: null,
        opt: 1,
        origin_mch: {},
      },
      change_apply_pic: [],
      mch_public_draft_list: [],
      uploadURL: "/mch_web/v1/upload_picture",
      loading: false,
      bankClassList: [],
      resultWallet: [],
    };
  },
  watch: {},
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isMobile() {
      return window.browserInfo.isMobile;
    },
  },
  filters: {
    type(source) {
      switch (source) {
        case 1:
          return "公司";
        case 2:
          return "个人";
        default:
          return source;
      }
    },
    status(source) {
      if (!source && source !== 0) {
        return "-";
      }
      switch (parseInt(source)) {
        case 1:
          return "填写中";
        case 2:
          return "审批中";
        case 3:
          return "审批通过";
        case 4:
          return "审批失败";
        case 5:
          return "用户撤回修改";
        case 6:
          return "审批中";
        default:
          return source;
      }
    },
    settle_type(source) {
      switch (source) {
        case 1:
          return "银行账号";
        case 2:
          return "钱包账号";
        default:
          return source;
      }
    },
    resp_per_id_type(source) {
      switch (source) {
        case "01":
          return "身份证";
        default:
          return source;
      }
    },
  },
  methods: {
    uploadListChange(file) {
      const { name, size } = file;
      if (this.change_apply_pic.length >= 9) {
        this.$alert(`图片最多上传9张，请先删除部分图片`, {
          type: "error",
        });
        return;
      }
      if (size < 2 * 1024 * 1024) {
        const fr = new FileReader();
        fr.onload = (e) => {
          this.loading = true;
          const result = e.target.result;
          // this.$set(this[previewKey], result);

          const pic_data = result.split(",")[1];

          //获取尾缀名
          const beginIdx = name.lastIndexOf(".");
          const endIdx = name.length;
          const ext = name.substring(beginIdx + 1, endIdx);
          const params = {
            pic_data,
            ext,
          };
          this.$store
            .dispatch("UPLOAD", params)
            .then(({ url }) => {
              this.change_apply_pic.push(url);
            })
            .catch(({ code, msg }) => {
              this.$alert(`图片上传失败。${code}：${msg}`, {
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        };
        fr.readAsDataURL(file.raw);
      } else {
        this.$alert("图片上传失败。文件大小超过2MB。", {
          type: "error",
        });
      }
    },
    // 获取回选的开户行 地 支行的信息
    async handleData(bankObj, item) {
      bankObj.bankClass = {
        class_code: item.deposit_bank_id,
        class_name: item.deposit_bank,
      };
      await this.getBankAreaList(bankObj);
      bankObj.bankArea = {
        area_code: item.area_id,
        city_name: item.deposit_bank_city,
        province_name: item.deposit_bank_province,
      };
      await this.getBankList(bankObj);
      bankObj.bank = {
        bank_code: item.union_bank,
        bank_name: item.sub_branch_bank,
      };
      await this.getBank(bankObj);
    },

    async getDetail() {
      try {
        this.loading = true;
        const { uname } = this.userInfo;
        let data = await this.$store.dispatch("GET_MCH_DETAIL", uname);
        let { status, wallet_audit_list, wallet_status } = await this.$store.dispatch(
          "MCH_AUDIT_STATUS"
        );
        const mch_public_draft_list = [];
        // 只有企业类型的时候，才需要对公相关的银行信息
        if (this.source.type == 1) {
          if (wallet_audit_list && Array.isArray(wallet_audit_list)) {
            wallet_audit_list.forEach((i) => {
              if (i.audit_status === 3) {
                const item = data.mch_public_draft_list.find((j) => {
                  return i.public_draft_id === j.id;
                });
                if (item) {
                  mch_public_draft_list.push(Object.assign(item, i, { bankObj: {} }));
                }
              }
            });
          }
        }
        for (let i = 0; i < mch_public_draft_list.length; i++) {
          await this.handleData(
            mch_public_draft_list[i].bankObj,
            mch_public_draft_list[i]
          );
        }

        this.mch_public_draft_list = mch_public_draft_list;
        console.log(this.mch_public_draft_list)
        this.$forceUpdate();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
        const { code, msg } = error;
        this.$alert(`获取商家钱包数据失败。${code}：${msg}`, {
          type: "error",
        });
      }
    },

    uploadChange(file, previewKey, urlKey) {
      const { name, size } = file;
      if (size < 0.5 * 1024 * 1024) {
        const fr = new FileReader();
        fr.onload = (e) => {
          this.loading = true;
          const result = e.target.result;
          this.$set(this.source, previewKey, result);

          const pic_data = result.split(",")[1];
          //获取尾缀名
          const beginIdx = name.lastIndexOf(".");
          const endIdx = name.length;
          const ext = name.substring(beginIdx + 1, endIdx);
          const params = {
            pic_data,
            ext,
          };
          this.$store
            .dispatch("UPLOAD", params)
            .then(({ url }) => {
              this.$set(this.source, urlKey, url);
            })
            .catch(({ code, msg }) => {
              this.$alert(`图片上传失败。${code}：${msg}`, {
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        };
        fr.readAsDataURL(file.raw);
      } else {
        this.$alert("图片上传失败。文件大小超过500KB。", {
          type: "error",
        });
      }
    },

    uploadPublicChange(file, idx) {
      const { name, size } = file;
      if (size < 2 * 1024 * 1024) {
        const fr = new FileReader();
        fr.onload = (e) => {
          this.loading = true;
          const result = e.target.result;
          const pic_data = result.split(",")[1];
          //获取尾缀名
          const beginIdx = name.lastIndexOf(".");
          const endIdx = name.length;
          const ext = name.substring(beginIdx + 1, endIdx);
          const params = {
            pic_data,
            ext,
          };
          this.$store
            .dispatch("UPLOAD", params)
            .then(({ url }) => {
              this.mch_public_draft_list[idx].public_account_pic = url;
            })
            .catch(({ code, msg }) => {
              this.$alert(`图片上传失败。${code}：${msg}`, {
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        };
        fr.readAsDataURL(file.raw);
      } else {
        this.$alert("图片上传失败。文件大小超过2MB。", {
          type: "error",
        });
      }
    },

    toMain() {
      this.$router.push("/merchants-information");
    },
    saveEdit() {
      if (this.validate()) {
        this.$refs.modifyMch.init();
      }
    },
    confirmPublic(idx, item) {
      if (!item.bankObj.bankClass.class_code) {
        this.$message({
          type: "warning",
          message: `钱包${idx + 1}-请选择开户银行`,
        });
        return false;
      } else if (!item.bankObj.bankArea.area_code) {
        this.$message({
          type: "warning",
          message: `钱包${idx + 1}-请选择开户银行所在地`,
        });
        return false;
      } else if (!item.bankObj.bank.bank_code) {
        this.$message({
          type: "warning",
          message: `钱包${idx + 1}-请选择支行名称`,
        });
        return false;
      } else if (!item.public_account) {
        this.$message({
          type: "warning",
          message: `钱包${idx + 1}-请输入对公账户账号`,
        });
        return false;
      } else if (!item.public_account_pic) {
        this.$message({
          type: "warning",
          message: `钱包${idx + 1}-请上传对公账户证明`,
        });
        return false;
      }
      return true;
    },
    validate() {
      this.resultWallet = [];
      for (let i = 0; i < this.mch_public_draft_list.length; i++) {
        let validate = this.confirmPublic(i, this.mch_public_draft_list[i]);
        if (validate) {
          let wallet = Object.assign({}, this.mch_public_draft_list[i], {
            area_id: this.mch_public_draft_list[i].bankObj.area_id,
            deposit_bank: this.mch_public_draft_list[i].bankObj.deposit_bank,
            deposit_bank_city: this.mch_public_draft_list[i].bankObj.deposit_bank_city,
            deposit_bank_id: this.mch_public_draft_list[i].bankObj.deposit_bank_id,
            deposit_bank_province: this.mch_public_draft_list[i].bankObj
              .deposit_bank_province,
            // bank_code: this.mch_public_draft_list[i].bankObj.bank_code,
            sub_branch_bank: this.mch_public_draft_list[i].bankObj.sub_branch_bank,
            union_bank: this.mch_public_draft_list[i].bankObj.union_bank,
          });
          delete wallet.bankObj;
          this.resultWallet.push(wallet);
        } else {
          break;
        }
      }
      if (this.resultWallet.length === this.mch_public_draft_list.length) {
        if (this.change_apply_pic.length < 1) {
          this.$message({
            type: "warning",
            message: `请上传修改函`,
          });
          return false;
        }
        return true;
      } else {
        false;
      }
    },

    toSaveEdit(biz_ticket) {
      this.loading = true;
      const source = Object.assign(
        {},
        {
          biz_ticket,
          change_apply_pic: this.change_apply_pic.toString(),
        }
      );
      source.mch_public_list = JSON.stringify(this.resultWallet);

      const action = "MODIFY_MCH_WALLET_INFO";
      this.$store
        .dispatch(action, source)
        .then(() => {
          this.$alert("您的钱包修改已提交审核", {
            type: "success",
          }).then(() => {
            this.toMain();
          });
        })
        .catch(({ code, msg }) => {
          if (code === 1004) {
            const start = msg.indexOf("：");
            const key = msg.substring(start + 1);
            const errorMsg = errorDictionaries[key];
            this.$message({
              type: "error",
              message: `${errorMsg}输入有误，请检查后，重新输入`,
            });
          } else {
            this.$message({
              type: "error",
              message: `${msg}`,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    abortEdit() {
      this.$confirm("是否确认放弃未保存的商家信息？", "提示")
        .then(() => {
          this.toMain();
        })
        .catch(() => {});
    },

    // 获取开户银行
    getBankClassList() {
      this.$store
        .dispatch("GET_BANK_CLASS_LIST")
        .then((data) => {
          this.bankClassList = data;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取银行列表失败。${code}：${msg}`,
          });
        });
    },

    // 获取开户银行区域
    getBankAreaList(bankObj) {
      return new Promise((resolve, reject) => {
        if (bankObj.bankClass.class_code) {
          bankObj.deposit_bank = bankObj.bankClass.class_name;
          bankObj.deposit_bank_id = bankObj.bankClass.class_code;
          this.$store
            .dispatch("GET_BANK_AREA_LIST", bankObj.bankClass.class_code)
            .then((data) => {
              bankObj.bankAreaList = data;
              bankObj.bankArea = {};
              bankObj.bank = {};
              this.$forceUpdate();
              resolve();
            })
            .catch(({ code, msg }) => {
              this.$message({
                type: "error",
                message: `获取银行地区列表失败。${code}：${msg}`,
              });
              resolve();
            });
        } else {
          bankObj.bankArea = {};
          bankObj.bank = {};
          bankObj.area_id = null;
          bankObj.deposit_bank_id = null;
          bankObj.deposit_bank = null;
          bankObj.deposit_bank_city = null;
          bankObj.sub_branch_bank = null;
          bankObj.union_bank = null;
          this.$forceUpdate();
          resolve();
        }
      });
    },

    // 获取支行
    getBankList(bankObj) {
      return new Promise((resolve, reject) => {
        if (bankObj.bankClass.class_code && bankObj.bankArea) {
          bankObj.bankArea = bankObj.bankArea;
          bankObj.deposit_bank_province = bankObj.bankArea.province_name;
          bankObj.deposit_bank_city = bankObj.bankArea.city_name;
          bankObj.area_id = bankObj.bankArea.area_code;
          const params = {
            class_code: bankObj.bankClass.class_code,
            area_code: bankObj.bankArea.area_code,
          };
          this.$store
            .dispatch("GET_BANK_LIST", params)
            .then((data) => {
              bankObj.bankList = data;
              bankObj.bank = {};
              this.$forceUpdate();
              resolve();
            })
            .catch(({ code, msg }) => {
              this.$message({
                type: "error",
                message: `获取支行列表失败。${code}：${msg}`,
              });
              resolve();
            });
        } else {
          bankObj.bank = {};
          bankObj.deposit_bank = null;
          bankObj.deposit_bank_city = null;
          bankObj.sub_branch_bank = null;
          bankObj.union_bank = null;
          this.$forceUpdate();
          resolve();
        }
      });
    },

    // 获取最后的支行
    getBank(bankObj) {
      if (bankObj.bank) {
        bankObj.sub_branch_bank = bankObj.bank.bank_name;
        bankObj.union_bank = bankObj.bank.bank_code;
      } else {
        bankObj.sub_branch_bank = null;
        bankObj.union_bank = null;
      }
      this.$forceUpdate();
    },
  },
  mounted() {
    this.getDetail();
    this.getBankClassList();
  },
};
</script>

<style lang="less" scoped>
.img-block {
  position: relative;
  float: left;
}
.del-img {
  // border: 1px solid red;
  background: red;
  color: #fff;
  position: absolute;
  top: 0;
  right: 20px;
  padding: 0 10px;
  text-align: center;
}
.editPublic {
  text-align: center;
  margin-bottom: 10px;
}
.tipTxt {
  color: red;
  text-align: center;
  margin-bottom: 10px;
}
.display-flex {
  flex-direction: column;
}
.wallet-info {
  border: 1px solid black;
  overflow: hidden;
  padding: 40px 20px 20px;
  margin: 20px;
}
.confirm-content {
  // border: 1px solid black;
  overflow: hidden;

  .txt-diff {
    color: red;
  }
}
.confirm-wallet {
  overflow: hidden;
  padding: 20px;
  border: 1px solid #333;
  margin: 20px;
}
.confirm-row {
  display: flex;
  // min-width: 800px;
  max-width: 1000px;
  .mch-image {
    img {
      width: 100%;
    }
  }
}
</style>
